export const STATUS_DRAFT = "DRAFT";
export const STATUS_PENDING = "PENDING";
export const STATUS_RUNNING = "RUNNING";
export const STATUS_COMPLETED = "COMPLETED";
export const STATUS_CANCELED = "CANCELED";
